import React from 'react';
import Text from '@lightspeed/cirrus-text';

import ShopIllustration from './ShopIllustration';

const Receipt = ({ children }) => (
  <div
    className="cr-pv-2 cr-pl-2 cr-background-no-repeat receipt-preview-bg cr-width-full"
    style={{ maxWidth: '356px', height: '559px', paddingRight: 'calc(0.75rem + 3px)' }}
  >
    <div className="cr-text-center cr-position-relative" style={{ height: '100%' }}>
      <div className="cr-p-2 cr-width-6-12" style={{ margin: '0 auto' }}>
        <ShopIllustration className="cr-width-full" />
      </div>
      {children}
      <div
        className="cr-position-absolute cr-flex cr-justify-center cr-width-full cr-flex-col cr-hidden-md-down"
        style={{ bottom: '1.5rem' }}
      >
        <Text body bold>
          Receipt example
        </Text>
      </div>
    </div>
  </div>
);

export default Receipt;
